import React from 'react'
import { Link as LinkRouter } from '@reach/router'
import './Link.css'

export const Link = ({ children, to, variant="primary" }) => (
    <LinkRouter to={to} className={`btn btn-${variant} mr-1`}>
        {children}
    </LinkRouter>
)